import { FC, memo } from 'react';

import styles from './Modal.module.scss';

interface ModalProps {
  title?: string;
  titleClass?: string;
  subTitle?: string;
  children: React.ReactNode;
}

export const Modal: FC<ModalProps> = memo(
  ({ title, titleClass, subTitle, children }) => {
    return (
      <div
        className={`${styles['modal-container']} h-100 row d-flex justify-content-center`}
      >
        <div className={styles['modal-backdrop']}></div>
        <div
          className={`${styles['modal-view']} d-flex align-items-center position-absolute rounded col-11 py-1 p-lg-4 card-max-width`}
        >
          <div className="modal-content">
            {title && (
              <div>
                <h2 className={`text-center mb-0 ${titleClass ?? ''}`}>
                  {title}
                </h2>
              </div>
            )}
            {subTitle && (
              <div className="py-1">
                <p className="text-center font-weight-medium fs-6">
                  {subTitle}
                </p>
              </div>
            )}
            {children}
          </div>
        </div>
      </div>
    );
  },
);
